// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"bd8bcf10","110":"872979e5","457":"e2d23873","556":"b86bec76","640":"ebe7066c","719":"2e7801b5","829":"28deb70a","864":"93c93f06","919":"5b24fd61"}[chunkId] + ".chunk.js";
};